import GoogleButton from 'components/common/Buttons/GoogleButton';
import Button from 'components/common/Buttons/index';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import { useAnimationWithWithoutScroll } from 'hooks/useAnimation';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentLocationIsLoading, selectCurrentLocationsTags } from 'store/slices/LocationsSlice';

const HeroComponent = ({ title, desc, ips, button_text, button_text_link, hasCrumbs }) => {
    const container = useRef();
    const isLoading = useSelector(selectCurrentLocationIsLoading)
    const currentLocationTags = useSelector(selectCurrentLocationsTags)

    useAnimationWithWithoutScroll({
        item: '.hero-body',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })
    useAnimationWithWithoutScroll({
        item: '.button',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })
    return (
        <div ref={container} className={`hero-container ${hasCrumbs ? "hero-container--with-crumbs" : ""}`}>
            {hasCrumbs && <HeroCrumbs page={title} locations={true} />}
            <div className='hero-body'>
                <div className='description1 hero-body__title'>{title}</div>
                <h1 className="hero-body__ips">{ips}</h1>
                <div className='body1 body1--M hero-body__desc'>{desc}</div>
            </div>
            <div className='hero-body-buttons'>
                <Button text={button_text} to={button_text_link} forPopup={true} />
                {
                    currentLocationTags.start_with_google_button && <GoogleButton />
                }

            </div>
        </div>
    );
}

export default HeroComponent;